import { template as template_20cb7e8183de4266926d149541ae98ae } from "@ember/template-compiler";
import { facetOptionDisabled } from 'client-portal/utils/clinicianSearch/facet-catalog';
import { fn } from '@ember/helper';
import { parseCommaSeparatedStrings } from 'client-portal/utils/clinicianSearch/comma-query-param';
import { service } from '@ember/service';
import { toArray } from 'client-portal/utils/clinicianSearch/service-facet-helpers/normalizing-facet';
import { toggleSelection } from 'client-portal/utils/clinicianSearch/toggle-selection';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import RequestClinicianSearchFiltersFilterCheckboxLine from '../filters/filter-checkbox-line';
import RequestClinicianSearchFiltersPanel from '../filters/panel';
import styles from './location.module.scss';
import t from 'ember-intl/helpers/t';
export default class RequestClinicianSearchFacetFiltersLocation extends Component {
    @service
    intl;
    @service
    store;
    @service
    clinicianSearch;
    styles = styles;
    @tracked
    selectedOfficeIds = [];
    @tracked
    officeCountById = new Map();
    @tracked
    officesLoadFailed = false;
    constructor(){
        super(...arguments);
        this.selectedOfficeIds = parseCommaSeparatedStrings(this.clinicianSearch.query.officeIds).map(this.canonicalOfficeId).filter(Boolean);
    }
    get filterOptionsLoadingAriaLabel() {
        return this.intl.t('booking.clinicianSearch.filterDetail.filterOptionsLoading');
    }
    get sortedPracticeOffices() {
        let offices = toArray(this.store.peekAll('office'));
        return [
            ...offices
        ].sort((a, b)=>this.officeLabel(a).localeCompare(this.officeLabel(b), undefined, {
                sensitivity: 'base'
            }));
    }
    canonicalOfficeId = (id)=>String(id ?? '').trim();
    refreshFacets = async ()=>{
        this.officesLoadFailed = false;
        try {
            let routeParams = {
                ...this.clinicianSearch.query.toRouteParams(),
                officeIds: null
            };
            let meta = this.clinicianSearch.sendAll.buildFacetsMeta(routeParams);
            this.officeCountById = new Map((meta?.facets?.offices ?? []).map((bucket)=>[
                    String(bucket.key),
                    bucket.count
                ]));
        } catch  {
            this.officesLoadFailed = true;
        }
    };
    isOfficeSelected = (id)=>{
        let sid = this.canonicalOfficeId(id);
        return !!sid && this.selectedOfficeIds.includes(sid);
    };
    docCountForOffice = (office)=>this.officeCountById.get(this.canonicalOfficeId(office.id)) ?? 0;
    officeOptionDisabled = (office)=>facetOptionDisabled(this.docCountForOffice(office), this.isOfficeSelected(office.id));
    officeRowTitle = (office)=>{
        if (!this.officeOptionDisabled(office)) {
            return '';
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.disabledFilterOption');
    };
    officeLabel = (office)=>{
        let name = String(office?.name ?? '').trim();
        if (name) {
            return name;
        }
        let address = this.officeAddressLabel(office);
        if (address) {
            return address;
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.officeUnknown', {
            id: office.id
        });
    };
    officeAddressLabel = (office)=>{
        let parts = [];
        if (office?.isPublic && office?.street) {
            parts.push(String(office.street).trim());
        }
        let cityState = [
            office?.city,
            office?.state
        ].map((v)=>String(v ?? '').trim()).filter(Boolean).join(', ');
        let zip = String(office?.formattedZip ?? office?.zip ?? '').trim();
        let cityStateZip = [
            cityState,
            zip
        ].filter(Boolean).join(' ');
        if (cityStateZip) {
            parts.push(cityStateZip);
        }
        return parts.join(', ');
    };
    toggleOffice = (id, event)=>{
        let sid = this.canonicalOfficeId(id);
        if (!sid) {
            return;
        }
        this.selectedOfficeIds = toggleSelection(this.selectedOfficeIds, sid, event.target.checked);
    };
    apply = ()=>{
        this.clinicianSearch.query.applyFacetFilter('location', this.selectedOfficeIds);
        this.clinicianSearch.mobile.backFromDetail();
    };
    static{
        template_20cb7e8183de4266926d149541ae98ae(`
    <RequestClinicianSearchFiltersPanel
      @applyDisabled={{false}}
      @class={{this.styles.component}}
      @facetKey="location"
      @isLoading={{this.clinicianSearch.sendAll.isLoading}}
      @loadingAriaLabel={{this.filterOptionsLoadingAriaLabel}}
      @onApply={{this.apply}}
      @onLoad={{this.refreshFacets}}
      data-test-clinician-search-filter-location-options
    >
      <p class="filter-section-title" id="clinician-search-location-filter-title">{{t
          "booking.clinicianSearch.filters.location"
        }}</p>
      {{#if this.officesLoadFailed}}
        <p class="error" data-test-clinician-search-filter-location-options-error>
          {{t "booking.clinicianSearch.filterDetail.locationsLoadError"}}
        </p>
      {{/if}}
      <div class="body" role="group" aria-labelledby="clinician-search-location-filter-title">
        <ul class="filter-checkbox-list" role="list">
          {{#each this.sortedPracticeOffices as |office|}}
            <RequestClinicianSearchFiltersFilterCheckboxLine
              @kind="office"
              @optionId={{office.id}}
              @docCount={{this.docCountForOffice office}}
              @title={{this.officeRowTitle office}}
              @checked={{this.isOfficeSelected office.id}}
              @disabled={{this.officeOptionDisabled office}}
              @onChange={{fn this.toggleOffice office.id}}
            >
              {{this.officeLabel office}}
            </RequestClinicianSearchFiltersFilterCheckboxLine>
          {{/each}}
        </ul>
      </div>
    </RequestClinicianSearchFiltersPanel>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
